import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import SupplyChain from "../../components/supply-chain";
import ExportImport from "../../components/export-import";

function ExportImportPage({ setShow }) {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>Export Import Management | GGAS</title>
        <meta name="keyword" content="GGAS" />
        <meta name="description" content="GGAS" />
      </Helmet>
      <Breadcrumb title={"Export Import Management"} t={t} />
      <ExportImport />
    </>
  );
}

export default ExportImportPage;
